<template lang="pug">
  .home
    .products
      .product(v-for="({ title, desc, src, price }, index) in products",
               :style="{ 'background-image': `url('${ src }')` }"
               :title="title",
               @click="select(products[index])",
               :class="{ first: !(index % 11) }")
        .title {{ title }}
        .price {{ price }}
    .modal(:class="{ shown: selectedBg }")
      .mask(:style="{ 'background-image': selectedBg }", @click="selected = {}")
      .product
        .bg(:style="{ 'background-image': selectedBg }")
        .info
          .title {{ selected.title }}
          .desc {{ selected.description || selected.desc }}
          .price {{ selected.price }}
            .shipping
             |
             | +
             span.dollar(v-if="selected.shipping")  $
             | {{ selected.shipping || '' }} shipping
          #payment-request-button(ref="prb", :class="{ hidepay }")
          paypal.pal(:amount="(/\$(\d+)/.exec(price) || [])[1]",
                     currency="USD",
                     :client="{ sandbox: '12345' }",
                     :button-style="{ shape: 'rect', color: 'black', size: 'medium' }",
                     env="sandbox")
          //.no-payments(:class="{ hidepay }") no payment method found
</template>
<script>
// @ is an alias to /src
//import HelloWorld from "@/components/HelloWorld.vue";
import paypal from 'vue-paypal-checkout';
import { mapActions } from 'vuex';
let stripe;
export default {
  name: 'home',
  data() {
    return {
      hidepay: true
    };
  },
  computed: {
    ...vuexComputed('products', 'selected'),
    selectedBg() {
      const { selected } = this;
      return selected.src && `url('${ selected.src }')`;
    }
  },
  methods: {
    ...mapActions(['addDescription', 'addShipping']),
    async select(product) {
      console.log({ product });
      this.selected = product;
      const { price, title: label, href, description, shipping } = product;
      const amount = (/\$(\d+)/.exec(price) || [])[1] * 100;
      let result;
      if (amount) {
        console.log('have amount', amount, href);
        const paymentRequest = stripe.paymentRequest({
          country: 'US',
          currency: 'usd',
          total: { label, amount },
          requestPayerName: true,
          requestPayerEmail: true,
          requestShipping: true,
          shippingOptions: []
        });
        const elements = stripe.elements();
        const button = elements.create('paymentRequestButton', { paymentRequest });

        // Check the availability of the Payment Request API first.
        result = await paymentRequest.canMakePayment();
        console.log({ result });
        if (result) {
          //button.mount('#payment-request-button');
          button.mount(this.$refs.prb);
        }
      }
      console.log({ price, amount });
      this.hidepay = !result;
      const [,id] = (/detail\.php\?id=(\d+)/.exec(href) || []);
      if (!description && id) {
        try {
          //const response = await fetch('http://localhost:8989/desc/' + id);
          const response = await fetch('https://tbcs.now.sh/desc/' + id);
          const value = await response.text();
          console.log(value);
          if (value) {
            this.addDescription({ item: product, value });
            const [,shipping] = (/\plus\s+\$([\w\.]+)\s+to/.exec(value) || []);
            if (shipping * 1) {
              this.addShipping({ item: product, value: shipping * 1 });
            }
            console.log({ shipping });
            this.$forceUpdate();
          }
        } catch (ex) {}
      }
      if (shipping) {
        paymentRequest.on('shippingaddresschange', async ev => {
          if (ev.shippingAddress.country !== 'US') {
            ev.updateWith({status: 'invalid_shipping_address'});
          } else {
            ev.updateWith({
              status: 'success',
              shippingOptions: [{
                id: 'domestic shipping',
                label: 'Domestic shipping',
                detail: '',
                amount: shipping * 100
              }],
              total: { label, amount: amount + (shipping * 100) }
            });
          }
        });
      }
    }
  },
  components: {
    paypal
  },
  mounted() {
    stripe = Stripe('pk_test_kBdkchtWtYBKshzR1FYjCCbS');
  }
};
function vuexComputed(...props) {
  return props.reduce((map, prop) => {
    return {
      ...map,
      [prop]: {
        get() {
          return this.$store.getters[prop];
        },
        set(value) {
          this.$store.dispatch(prop, value);
        }
      }
    };
  }, {});
}
</script>
<style scoped lang="scss">
.home {
  max-width: 1000px;
  width: 100vw;
  margin: 0 auto;
  .products {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .product {
      outline: 1px solid white;
      width: 25%;
      padding-top: 34%;
      position: relative;
      background: no-repeat center;
      background-size: cover;
      transform-origin: center;
      transform: scale(1);
      transition: transform 150ms ease-out;
      -webkit-tap-highlight-color: transparent;
      //box-shadow: 0 0 3vw 2vw #8d6e4f;
      &.first,
      &.first + .product + .product + .product + .product + .product {
        width: 66%;
        padding-top: 90%;
      }
      &.first + .product + .product + .product + .product + .product {
        margin-left: 16%;
      }
      &.first + .product,
      &.first + .product + .product,
      &.first + .product + .product + .product,
      &.first + .product + .product + .product + .product, {
        width: 34%;
        padding-top: 45%;
        height: 50%;
      }
      &.first + .product + .product,
      &.first + .product + .product + .product + .product {
        transform: translate3d(47%, 211%, 0);
        margin-left: -50%;
        margin-top: -50%;
      }
      &.first + .product + .product + .product + .product {
        //transform: translate3d(47%, 211%, 0);
        //margin-left: -50%;
        //margin-top: -50%;
      }
      &.first + .product + .product + .product + .product + .product + .product,
      &.first + .product + .product + .product + .product + .product + .product + .product,
      &.first + .product + .product + .product + .product + .product + .product + .product + .product,
      &.first + .product + .product + .product + .product + .product + .product + .product + .product + .product,
      &.first + .product + .product + .product + .product + .product + .product + .product + .product + .product {
        //normal
      }
      &.first + .product + .product + .product + .product + .product + .product + .product + .product + .product + .product {
        width: 100%;
        padding-top: 136%;
      }
      .title {
        position: absolute;
        top: 2vh;
        left: 0;
        right: 0;
        color: white;
        text-shadow: 0 0 1px black, 0 0 3px black;
        text-align: center;
        content: attr(title);
        font-size: 2.75vw;
        font-family: sans-serif;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border: 0.25vw solid transparent;
        border-left-width: 0;
        border-right-width: 0;
      }
      .price {
        position: absolute;
        bottom: 2vh;
        left: 0;
        right: 0;
        color: white;
        text-shadow: 0 0 1px black, 0 0 2px black;
        text-align: center;
        content: attr(title);
        font-size: 4.75vw;
        font-family: sans-serif;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border: 0.25vw solid transparent;
        border-left-width: 0;
        border-right-width: 0;
      }
    }
  }
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    transform: translate3d(0, -100%, 0);
    transition: transform 400ms ease-in-out;
    will-change: transform;
    &.shown {
      transform: translate3d(0, 0, 0);
    }
    .mask {
      position: absolute;
      background: rgba(40, 40, 40, 0.9) no-repeat center;
      background-size: cover;
      filter: blur(8px) sepia(60%);
      opacity: 0.98;
      //background-color: rgba(255, 255, 255);
      height: 100%;
      width: 100%;
    }
    .product {
      border: 4px solid white;
      background-color: white;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      display: flex;
      flex-direction: column;
      width: 90vw;
      .bg {
        width: 100%;
        height: 40vh;
        background: no-repeat center;
        background-size: cover;
      }
      .info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 1rem 3rem;
        .title {
          font-size: 3vh;
          margin-bottom: 1vh;
        }
        .desc {
          font-size: 0.95rem;
          min-height: 7rem;
        }
        .price {
          font-size: 5vh;
          .shipping {
            color: #848484;
            font-size: 0.45em;
          }
        }
        .pal {
          margin: 1vw;
        }
        .no-payments {
          display: none;
          &.hidepay {
            display: block;
            text-align: center;
            font-style: italic;
            color: red;
          }
        }
      }
    }
  }
}
</style>
